import { lazy } from "react";

const About = lazy(() => import("../presentation/about"));
const ContactUs = lazy(() => import("../presentation/contactUs"));
const Home = lazy(() => import("../presentation/home"));

const publicRoutes = [
  {
    path: "/",
    exact: true,
    component: Home,
    isAuth: false,
    title: "Home",
  },
  {
    path: "/about",
    component: About,
    isAuth: false,
    title: "About",
  },
  {
    path: "/contact-us",
    component: ContactUs,
    isAuth: false,
    title: "Contact US",
  },
];

const routes = [...publicRoutes];

export default routes;
